import { Component, Input, OnInit } from '@angular/core';
import $ from 'jquery';
import { Page } from '../../../../models/page';
import { PageService } from '../../../../services/page.service';
import { AssetService } from '../../../../services/asset.service';
import { fromEvent } from 'rxjs';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
    selector: 'sidebar-thumbnail-page-image',
    templateUrl: './thumbnail-page-image.component.html',
    styleUrls: ['./thumbnail-page-image.component.scss'],
    standalone: true,
    imports: [
        LazyLoadImageModule
    ]
})
export class ThumbnailPageImageComponent implements OnInit {

    @Input() page: Page;
    @Input() width: number;
    @Input() height: number;
    loading = true;
    scrollContainer;
    scrollObservable;
    defaultImage: string;

    constructor(private pageService: PageService, private assetService: AssetService) {

    }

    ngOnInit(): void {
        this.defaultImage = this.assetService.getUrl('transparent.png');
        this.scrollContainer = $('.sidebar-content-wrapper');
        this.scrollObservable = fromEvent(this.scrollContainer, 'scroll');

        // Workaround - After init no scroll event is emitted and so lazy loading is not triggered
        setTimeout(() => {
            this.scrollContainer.scroll();
        }, 100);

        if (!this.page && this.width > this.height) {
            this.height++;
        }

    }

    getRealPageNumber(page: Page): number {
        if (page) {
            return this.pageService.getRealPageNumber(page.index);
        }

        return -1;
    }

}
